import { createContext } from 'react';
import type { TUserContextValue } from './User.types.ts';

export const UserContext = createContext<TUserContextValue | undefined>(
  undefined,
);
